import { useContext } from 'react';
import { DocumentSettingsContext } from '../DocumentSettingsContext';
import { getCanvasMinHeight, getCanvasWidth } from '../../../../shared/gridConfig';
import type { MarginSide } from '../models/MarginSide.enum';
import { MarginSettingsView } from './MarginSettingsView';
import { useEffectiveOrientation } from 'hooks/useEffectiveOrientation';

const MarginSettings = () => {
  const { documentSettings, updateMargins } = useContext(DocumentSettingsContext);
  const effectiveOrientation = useEffectiveOrientation();
  const canvasWidth = getCanvasWidth(effectiveOrientation);
  const canvasHeight = getCanvasMinHeight(effectiveOrientation);
  const previewWidth = effectiveOrientation === 'landscape' ? 140 : 110;
  const previewHeight = effectiveOrientation === 'landscape' ? 110 : 140;

  const handleChange = (value: string | number, position: MarginSide) => {
    updateMargins(value, position);
  };

  return (
    <MarginSettingsView
      margin={documentSettings.margin}
      canvasWidth={canvasWidth}
      canvasHeight={canvasHeight}
      previewWidth={previewWidth}
      previewHeight={previewHeight}
      onChange={handleChange}
    />
  );
};

export default MarginSettings;
